const metrics = {
  paymentOptionWidth: 112,
  paymentOptionSpacing: 4,
}

export default metrics
